import { NgModule } from '@angular/core';
import { AuthEffects } from './state/auth.effects';
import { AkitaNgEffectsModule } from '@datorama/akita-ng-effects';
import { LoginModule } from './login/login.module';

@NgModule({
  imports: [LoginModule, 
    AkitaNgEffectsModule.forFeature([AuthEffects])],
})
export class AuthModule { }
